import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMyAgency } from "../utils/api";


export const fetchMyAgency = createAsyncThunk(
  'myAgency/fetchMyAgency',
  async ({ accessToken, query, activeTab }, { rejectWithValue }) => {
    try {
      const response = await getMyAgency(accessToken, query, activeTab);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const myAgencySlice = createSlice({
  name: 'myAgency',
  initialState: {
    myAgency: [],
    loading: false,
    error: null,
    meta: {},
    user: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyAgency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyAgency.fulfilled, (state, action) => {
        state.loading = false;
        state.myAgency = action.payload.data;
        state.meta = action.payload.meta;
        state.user = action.payload.user;
      })
      .addCase(fetchMyAgency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default myAgencySlice.reducer;
